@if (sliderStepsTmpl?.length) {
  <div class="z-fx z-fx-fill z-fx-around-start slider-steps">
    @for (step of sliderStepsTmpl; track step; let idx = $index) {
      <div
        class="z-fx-flex zef-text-center zef-text-p2 slider-step"
        [ngClass]="isStepActive(idx) ? 'zef-color-primary' : 'zef-text-p2-muted'"
        (click)="onStepClick(idx)"
      >
        @if (idx && funnelMode) {
          <mat-icon class="zef-color-space-darkest zef-icon-large slider-funnel">breadcrumb</mat-icon>
        }
        <ng-container [ngTemplateOutlet]="step.tr"></ng-container>
      </div>
    }
  </div>
}

@if (!disabled) {
  <div #wrapper class="wrapper">
    <div class="track">
      @for (_ of steps_; track _) {
        <div class="step"></div>
      }
      <div class="progress" [ngStyle]="progressStyle$ | async"></div>
    </div>
    @if (thumb1 != null) {
      <div class="thumb" [style.left.%]="thumb1Left$ | async"></div>
    }
    <div class="thumb" [style.left.%]="thumb2Left$ | async"></div>
  </div>
}

@if (sliderLabelTmpl?.tr && !disabled) {
  <div class="label-wrapper">
    <div class="label" [ngStyle]="labelStyle$ | async" #sliderLabel>
      <ng-container [ngTemplateOutlet]="sliderLabelTmpl.tr"></ng-container>
    </div>
  </div>
}
